import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pa-2 text-left" }
const _hoisted_2 = {
  key: 1,
  class: "text-center text-medium-emphasis my-6"
}
const _hoisted_3 = { class: "text-subtitle-1 font-weight-bold mb-2" }

import { computed, ref } from "vue";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { partidaJugada } from "@/utils/clasificacionLiga";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabJornadasLiga',
  props: {
    partidas: {},
    jornadas: {},
    editable: { type: Boolean },
    numeroGrupos: {}
  },
  emits: ["partidaActualizada"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const jornada = ref(0);
const estado = ref<"todas" | "pendientes" | "jugadas">("todas");
const jugador = ref<number | null>(null);
const grupoFiltro = ref(0);

const pendientes = computed(
  () => props.partidas.filter(p => !partidaJugada(p)).length
);

const jugadores = computed(() => {
  const porId = new Map<number, string>();
  props.partidas.forEach(p => {
    porId.set(p.idUsuario1, p.nick1);
    porId.set(p.idUsuario2, p.nick2);
  });
  return [...porId.entries()]
    .map(([idUsuario, nick]) => ({ idUsuario, nick }))
    .sort((a, b) => a.nick.localeCompare(b.nick));
});

const porJornadas = computed(() => {
  const filtradas = props.partidas.filter(
    p =>
      (grupoFiltro.value === 0 || p.grupo === grupoFiltro.value) &&
      (jornada.value === 0 || p.numeroRonda === jornada.value) &&
      (estado.value === "todas" ||
        (estado.value === "jugadas") === partidaJugada(p)) &&
      (jugador.value === null ||
        p.idUsuario1 === jugador.value ||
        p.idUsuario2 === jugador.value)
  );
  const porJornada = new Map<number, PartidaTorneoDTO[]>();
  filtradas.forEach(p => {
    porJornada.set(p.numeroRonda, [
      ...(porJornada.get(p.numeroRonda) ?? []),
      p,
    ]);
  });
  return [...porJornada.entries()]
    .sort(([a], [b]) => a - b)
    .map(([numero, partidas]) => ({ jornada: numero, partidas }));
});


return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.numeroGrupos)
      ? (_openBlock(), _createBlock(_component_v_chip_group, {
          key: 0,
          modelValue: grupoFiltro.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((grupoFiltro).value = $event)),
          column: "",
          mandatory: "",
          "selected-class": "text-primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_chip, {
              value: 0,
              size: "small",
              filter: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Todos los grupos")
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeroGrupos, (g) => {
              return (_openBlock(), _createBlock(_component_v_chip, {
                key: g,
                value: g,
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Grupo " + _toDisplayString(g), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_chip_group, {
      modelValue: jornada.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((jornada).value = $event)),
      column: "",
      mandatory: "",
      "selected-class": "text-primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_chip, {
          value: 0,
          size: "small",
          filter: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Todas")
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jornadas, (n) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: n,
            value: n,
            size: "small",
            filter: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" J" + _toDisplayString(n), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_chip_group, {
      modelValue: estado.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((estado).value = $event)),
      column: "",
      mandatory: "",
      "selected-class": "text-primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_chip, {
          value: "todas",
          size: "small",
          filter: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Todas")
          ]),
          _: 1
        }),
        _createVNode(_component_v_chip, {
          value: "pendientes",
          size: "small",
          filter: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Pendientes (" + _toDisplayString(pendientes.value) + ") ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_chip, {
          value: "jugadas",
          size: "small",
          filter: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Jugadas (" + _toDisplayString(_ctx.partidas.length - pendientes.value) + ") ", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_autocomplete, {
      modelValue: jugador.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((jugador).value = $event)),
      items: jugadores.value,
      "item-title": "nick",
      "item-value": "idUsuario",
      label: "Partidas de un jugador",
      density: "compact",
      clearable: "",
      "hide-details": "",
      class: "mb-3"
    }, null, 8, ["modelValue", "items"]),
    (porJornadas.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No hay partidas con estos filtros. "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(porJornadas.value, (bloque) => {
      return (_openBlock(), _createElementBlock("div", {
        key: bloque.jornada,
        class: "mb-4"
      }, [
        _createElementVNode("h3", _hoisted_3, " Jornada " + _toDisplayString(bloque.jornada), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bloque.partidas, (partida) => {
          return (_openBlock(), _createBlock(CardPartidaGestion, {
            key: partida.idPartidaTorneo,
            partida: partida,
            editable: _ctx.editable,
            etiqueta: _ctx.numeroGrupos ? `Grupo ${partida.grupo}` : undefined,
            onPartidaActualizada: _cache[4] || (_cache[4] = ($event: any) => (emit('partidaActualizada', $event)))
          }, null, 8, ["partida", "editable", "etiqueta"]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})